import Modal from "@mui/material/Modal";
import {kModalStyles} from "../../../constants/styles";
import {kSystemIcons} from "../../../constants/icons";
import BrevetScreenInfoDialogTexts from "../../texts/brevetScreen/BrevetScreenInfoDialogTexts";
import SystemScreenInfoHeader from "../../headers/SystemScreenInfoHeader";
import {kBrevetScreenImages} from "../../../constants/images";

export default function BrevetScreenInfoDialog({open, handleClose}) {
    // Used through app screen headers to handle info about current
    // screen concept

    // BUILD
    return (
        <Modal open={open}
               onClose={handleClose}>
            <div className={kModalStyles.screenInfoDialogStyle}>
                <SystemScreenInfoHeader handleClose={handleClose}
                                        icon={kSystemIcons.school}
                                        title={"Brevet"}
                                        isBrevet={true} />
                {/** CONTENT */}
                <div className={"w-full flex justify-start items-start space-x-[24px] px-[24px] pt-[24px] pb-[16px]"}>
                    <div className={"w-[120px] min-w-[120px]"}>
                        <img
                            className={"object-contain h-full w-full"}
                            src={kBrevetScreenImages.screenInfoImage}
                            alt="Les jeux éducatifs"
                        />
                    </div>
                    <BrevetScreenInfoDialogTexts />
                </div>
            </div>
        </Modal>
    );
}